"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchParams = exports.useSearchFilterItems = void 0;
var _ChipsFilter = require("./ChipsFilter.hooks");
var _react = require("react");
var _core = require("@focaltec-suite/core");
var useSearchFilterItems = exports.useSearchFilterItems = function useSearchFilterItems() {
  var filters = (0, _react.useMemo)(function () {
    return [{
      name: 'search',
      label: (0, _core.translate)('filters.search'),
      type: 'text'
    }];
  }, []);
  return filters;
};
var useSearchParams = exports.useSearchParams = function useSearchParams(query) {
  var items = useSearchFilterItems();
  var params = (0, _ChipsFilter.useFilterParams)(items, query);
  return params;
};